import api from './client';

// Market Movers
export const getMarketMovers = (period = '7d', limit = 20, direction = 'all') =>
  api.get('/api/dashboard/market-movers', { params: { period, limit, direction } }).then(r => r.data);

export const getMarketSummary = () =>
  api.get('/api/dashboard/market-movers/summary').then(r => r.data);

// Deal Finder
export const getDeals = (minMargin = 10, limit = 20) =>
  api.get('/api/dashboard/deals', { params: { min_margin: minMargin, limit } }).then(r => r.data);

// Arbitrage
export const getArbitrage = (minMargin = 5, limit = 30) =>
  api.get('/api/dashboard/arbitrage', { params: { min_margin: minMargin, limit } }).then(r => r.data);

// Price Check
export const getPriceCheck = (cardId: string) =>
  api.get(`/api/dashboard/price-check/${cardId}`).then(r => r.data);

// Grading Checker
export const getGradingCheck = (cardId: string) =>
  api.get(`/api/grading-checker/check/${cardId}`).then(r => r.data);

// Search cards (via grading-checker which has the search built-in)
export const searchCards = (q: string) =>
  api.get('/api/grading-checker/check', { params: { q } }).then(r => {
    // Returns either { suggestions: [...] } or the card data directly
    if (r.data.suggestions) {
      return { cards: r.data.suggestions };
    }
    return { cards: [], direct: r.data };
  });
